import React from "react";
import SearchForm from "../components/SearchForm";

const Home = () => {
  return (
    <>
      <SearchForm />
    </>
  );
};

export default Home;
